import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface ISchedulePanelStyles {
  root?: IStyle;
}

export interface ISchedulePanelClassNames {
  root: string;
}

export const schedulePanelStylesDefault = (_theme: IH2OTheme): Partial<ISchedulePanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
